import { useStripe } from '@stripe/react-stripe-js';
import React, { } from 'react';
import PlanPurchaseSummary from './PlanPurchaseSummary';

const PlanPurchaseSummaryContainer = () => {
    const stripe = useStripe();
    return (  
        <PlanPurchaseSummary stripe={stripe}></PlanPurchaseSummary>
    );
}
 
export default PlanPurchaseSummaryContainer;